import { render } from "./SearchResultPages.vue?vue&type=template&id=42626ee5"
import script from "./SearchResultPages.vue?vue&type=script&lang=js"
export * from "./SearchResultPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__